import { BuzzkuriBreadcrumb } from '@components/buzzkuri/shared/uiParts/breadcrumb/BuzzkuriBreadcrumb'
import { ProgramsCategoryPageContentAndSlugs } from '@type/buzzkuri/programs-categor'
import { cloudfrontPath } from '@utils/image'
import { isValidProps } from '@utils/validate'
import { CategoryNavList } from '../../Programs/CategoryNavList'
import { IntroductionCompanies } from '../../Programs/IntroductionCompanies'
import { NewArrivalsColumn } from '../../Programs/NewArrivalsColumn'
import { CategoryCase } from './CategoryCase'
import { CategoryFeatures } from './CategoryFeatures'
import { CategoryLecturers } from './CategoryLecturers'
import { CategoryObjectives } from './CategoryObjectives'
import { DigestMovie } from './DigestMovie'
import { GuestsVoices } from './GuestsVoices'
import { PopularProgram } from './PopularProgram'
import { ResolveProblems } from './ResolveProblems'
import { TargetProgramList } from './TargetProgramList'
import { CategoryNavigatorImage } from './CategoryNavigatorImage'

export const ProgramCategory = ({
  slugs,
  pageContent,
}: ProgramsCategoryPageContentAndSlugs): JSX.Element => {
  const {
    popularPrograms,
    currentItemsCount,
    totalItemsCount,
    currentPageNumber,
    programs,
    resolveProblems,
    categoryPurpose,
    features,
    digestMovie,
    guestsVoices,
    caseStudy,
    lecturers,
    feedItems,
    objectiveName,
  } = pageContent
  return (
    <>
      {objectiveName && (
        <CategoryNavigatorImage objectiveName={objectiveName} />
      )}

      <div className={objectiveName ? "mt-[10.3em] md:mt-[0vw]" : ""}>
        <div className="mt-[3.2vw] lg:mt-[2.4vw]">
          <BuzzkuriBreadcrumb />
        </div>

        {isValidProps(programs) && (
          <div className="mt-[10.6vw] lg:mt-[3vw]">
            <TargetProgramList
              slug={slugs[0]}
              heading={`${slugs[0]}のプログラム一覧(対面/オンライン)`}
              MainHeadingTag="h2"
              {...{
                currentItemsCount,
                totalItemsCount,
                currentPageNumber,
                programs,
                slugs,
              }}
              ProgramHeadingTag="h3"
            />
          </div>
        )}

        {isValidProps(popularPrograms) && (
          <div className="mt-[16vw] lg:mt-[8vw]">
            <PopularProgram {...{ popularPrograms, slugs }} />
          </div>
        )}

        <div id="articles">
          {isValidProps(resolveProblems) && (
            <div className="mt-[16vw] lg:mt-[8vw]">
              <ResolveProblems
                {...{ resolveProblems }}
                iconPath={`${cloudfrontPath}/programs/icons/program-category/resolve_problem_check.svg`}
              />
            </div>
          )}

          {isValidProps(categoryPurpose) && (
            <div className="mt-[10.7vw] lg:mt-[4.3vw]">
              <CategoryObjectives {...{ categoryPurpose }} />
            </div>
          )}

          {isValidProps(features) && (
            <div className="mt-[10.7vw] lg:mt-[3.4vw]">
              <CategoryFeatures {...{ features, slugs }} />
            </div>
          )}
          {isValidProps(digestMovie) && (
            <>
              <span id="digestMovie"></span>
              <div className="mt-[10.7vw] lg:mt-[3.4vw]">
                <DigestMovie {...{ digestMovie }} />
              </div>
            </>
          )}

          {isValidProps(guestsVoices) && (
            <div className="mt-[10.7vw] lg:mt-[3.6vw]">
              <GuestsVoices {...{ guestsVoices }} />
            </div>
          )}

          {isValidProps(caseStudy) && (
            <div className="mt-[10.7vw] lg:mt-[3.6vw]">
              <CategoryCase {...{ caseStudy }} />
            </div>
          )}

          {isValidProps(lecturers) && (
            <div className="mt-[10.7vw] lg:mt-[4.4vw]">
              <CategoryLecturers {...{ lecturers }} />
            </div>
          )}

          <div className="mt-[10vw] lg:mt-[4.7vw]">
            <IntroductionCompanies />
          </div>

          {isValidProps(feedItems) && (
            <div className="mt-[16vw] lg:mt-[4vw]">
              <NewArrivalsColumn {...{ feedItems }} />
            </div>
          )}
        </div>

        <div className="mt-[16vw] lg:mt-[6.3vw]">
          <CategoryNavList />
        </div>
      </div>
    </>
  )
}
